/**
 * ============================================================================
 * EVENT BUS ДЛЯ VUE 3
 * ============================================================================
 * Простой event emitter для коммуникации между компонентами
 * Замена для $root.$on/$off/$emit из Vue 2
 * ============================================================================
 */

class EventBus {
	constructor() {
		this.events = {}
	}

	/**
	 * Подписаться на событие
	 * @param {string} event - Название события
	 * @param {Function} callback - Функция-обработчик
	 */
	on(event, callback) {
		if (!this.events[event]) {
			this.events[event] = []
		}
		this.events[event].push(callback)
	}

	/**
	 * Отписаться от события
	 * @param {string} event - Название события
	 * @param {Function} callback - Функция-обработчик (опционально)
	 */
	off(event, callback) {
		if (!this.events[event]) {
			return
		}

		if (!callback) {
			// Удалить все обработчики события
			delete this.events[event]
		} else {
			// Удалить конкретный обработчик
			this.events[event] = this.events[event].filter(cb => cb !== callback)
		}
	}

	/**
	 * Отправить событие
	 * @param {string} event - Название события
	 * @param {*} data - Данные события
	 */
	emit(event, data) {
		if (!this.events[event]) {
			return
		}

		this.events[event].forEach(callback => {
			callback(data)
		})
	}

	/**
	 * Подписаться на событие один раз
	 * @param {string} event - Название события
	 * @param {Function} callback - Функция-обработчик
	 */
	once(event, callback) {
		const onceCallback = data => {
			callback(data)
			this.off(event, onceCallback)
		}
		this.on(event, onceCallback)
	}
}

// Создаем глобальный экземпляр
export const eventBus = new EventBus()

export default eventBus

